var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDowngrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.476,
    height: 9.595,
    viewBox: "0 0 7.476 9.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-8.759 -6.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6133",
    "data-name": "Path 6133",
    d: "M16.086,12.253a.513.513,0,0,0-.723,0l-2.379,2.338v-7.3a.513.513,0,0,0-1.025,0v7.281L9.636,12.253a.513.513,0,1,0-.728.723l3.266,3.266a.461.461,0,0,0,.651,0l3.261-3.266a.513.513,0,0,0,0-.723Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDowngrade);
export default __webpack_public_path__ + "static/media/icon_downgrade.46400c0b04afb29b17b108dfb6a467d4.svg";
export { ForwardRef as ReactComponent };